import React from 'react';
import { motion } from 'framer-motion';
const ResultsSection: React.FC = () => {
  return <section className="w-full bg-white py-16" data-id="element-216">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-218">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-secondary mb-6" data-id="element-219">
            Los cambios que notarás
          </h2>
        </motion.div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-220">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="bg-background p-5 rounded-lg shadow text-center" data-id="element-221">
            <p data-id="element-222">Adiós barriga hinchada en pocos días.</p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.15
        }} className="bg-background p-5 rounded-lg shadow text-center" data-id="element-223">
            <p data-id="element-224">Pantalones que vuelven a entrar 😍.</p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.2
        }} className="bg-background p-5 rounded-lg shadow text-center" data-id="element-225">
            <p data-id="element-226">2–4 kg menos de retención y líquidos.</p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.25
        }} className="bg-background p-5 rounded-lg shadow text-center" data-id="element-227">
            <p data-id="element-228">Menos antojos + menos ansiedad.</p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.3
        }} className="bg-background p-5 rounded-lg shadow text-center" data-id="element-229">
            <p data-id="element-230">Mejor humor.</p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.35
        }} className="bg-background p-5 rounded-lg shadow text-center" data-id="element-231">
            <p data-id="element-232">Piel más luminosa.</p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.4
        }} className="bg-background p-5 rounded-lg shadow text-center" data-id="element-233">
            <p data-id="element-234">Mejor descanso.</p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.45
        }} className="bg-background p-5 rounded-lg shadow text-center" data-id="element-235">
            <p data-id="element-236">Orgullo → autoestima al alza.</p>
          </motion.div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-237">
          <p className="text-2xl font-medium text-primary-dark" data-id="element-238">
            Este es tu reset. Y lo vas a lograr.
          </p>
        </motion.div>
      </div>
    </section>;
};
export default ResultsSection;